import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-aramark-table',
  templateUrl: './aramark-table.component.html',
  styleUrls: ['./aramark-table.component.scss']
})
export class AramarkTableComponent implements OnInit {

  @Input() titles: string[] = [];
  @Input() totalResults: number = 0;
  @Input() page: number = 1
  pageLimit=10

  @Output() pageChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any){
    console.log(changes)
    /* if (changes?.page) this.page = changes?.page
    if (changes?.totalResults) this.totalResults = changes?.page */
    
  }

  pageChanged(event: PageChangedEvent): void {
    this.page = event?.page ? event?.page : this.page
    this.pageChange.emit({page: this.page, pageLimit: this.pageLimit});
  }

}
